import PropTypes from "prop-types";
import React from "react";

function ProfileHeaderLocation({ location = undefined }) {
  if (!location) return null;

  return (
    <div className="text-body-secondary mb-1">
      <i className="fa-solid fa-map-marker me-1" />
      {location}
    </div>
  );
}

ProfileHeaderLocation.propTypes = { location: PropTypes.string };

export default ProfileHeaderLocation;
